import React from "react";
import { IResourceComponentsProps, useTranslate } from "@refinedev/core";
import { Create, useForm } from "@refinedev/antd";
import { Form, Input, Select, Row, Col } from "antd";
import { AccountType } from "../../models/account";
import { useSelectValues } from "./values";

export const AccountCreate: React.FC<IResourceComponentsProps> = () => {
  const translate = useTranslate();
  const { formProps, saveButtonProps } = useForm();
  const accountType = Form.useWatch("type", formProps.form);

  const { accountTypes, billingModes } = useSelectValues();

  return (
    <Create saveButtonProps={saveButtonProps}
      title={translate("accounts.titles.create")}>
      <Form {...formProps} layout="vertical" >
        <Row gutter={{ xs: 8, sm: 16, md: 24 }}>
          <Col xs={12} sm={8} md={6}>
            <Form.Item
              label={translate("accounts.fields.type")}
              initialValue={accountTypes[0].value}
              name={["type"]}
              rules={[{ required: true }]}
            >
              <Select options={accountTypes} />
            </Form.Item>
          </Col>
          {accountType === AccountType.company ? (
            <>
              <Col xs={12} sm={8} md={6}>
                <Form.Item
                  label={translate("accounts.fields.name")}
                  name={["name"]}
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} md={6}>
                <Form.Item
                  label={translate("accounts.fields.legalId")}
                  name={["legalId"]}
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </>
          ) : (
            <>
              <Col xs={12} sm={8} md={6}>
                <Form.Item
                  label={translate("accounts.fields.firstName")}
                  name={["firstName"]}
                  rules={[
                    {
                      required: true,
                      message: translate(
                        "accounts.validation.firstNameRequiredForIndividual",
                      ),
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} md={6}>
                <Form.Item
                  label={translate("accounts.fields.lastName")}
                  name={["lastName"]}
                  rules={[
                    {
                      required: true,
                      message: translate(
                        "accounts.validation.lastNameRequiredForIndividual",
                      ),
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </>
          )}
          <Col xs={12} sm={8} md={6}>
            <Form.Item
              label={translate("accounts.fields.address")}
              name={["address"]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={12} sm={8} md={6}>
            <Form.Item
              label={translate("accounts.fields.phone")}
              name={["phone"]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={12} sm={8} md={6}>
            <Form.Item
              label={translate("accounts.fields.email")}
              name={["email"]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={12} sm={8} md={6}>
            <Form.Item
              label={translate("accounts.fields.billingMode")}
              name={["billingMode"]}
              initialValue={billingModes[0].value}
              rules={[{ required: true }]}
            >
              <Select options={billingModes} />
            </Form.Item>
            <Form.Item name={["status"]} initialValue={"active"} hidden>
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={{ xs: 8, sm: 16, md: 24 }}>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label={translate("accounts.fields.bFlashApiKey")}
              name={["bFlashApiKey"]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
